import type { PositionPlanPositioningProps } from "./position-plan-positioning.type";

import PositionMarker from "@/modules/position/position-marker";
import { PdfViewer } from "@/ui/pdf-viewer";

import { usePositionPlanPositioning } from "./position-plan-positioning.hook";

const PositionPlanPositioning = (props: PositionPlanPositioningProps) => {
  const { planSourceUrl, toolbarOptions, fitToWrapper, className } = props;

  const {
    markerPage,
    initialPage,
    controlledPage,
    marker,
    onPageChange,
    setPdfSize,
    onPdfClick,
  } = usePositionPlanPositioning(props);

  return (
    <PdfViewer
      source={planSourceUrl}
      initialPage={initialPage}
      controlledPage={controlledPage}
      toolbarOptions={{
        showPagination: true,
        showZoom: false,
        showGoToHighlightPage: true,
        ...toolbarOptions,
      }}
      highlightPage={markerPage}
      onPageChange={onPageChange}
      onPageSizeChange={setPdfSize}
      onPdfClick={onPdfClick}
      fitToWrapper={fitToWrapper}
      className={className}
      testId="plan-positioning-pdf"
    >
      {marker && <PositionMarker position={marker} />}
    </PdfViewer>
  );
};

export default PositionPlanPositioning;
